<template>
    <div class="wrap">
        <!--文件夹选项-->
        <div  class="wrap-docMag">
            <div class="btn-group">
                <button v-for="(item,index) in tab" :key="item" @click="activeTab(index)" :class="{btnSelected:activeIndex == index}">{{ item }}</button>
            </div>
            <p class="title">注：文档类型等同于任务类型</p>
            <z-scrollDiv class="doc-main">
                <ul class="folder" v-show="activeIndex == 0">
                    <li v-for="item in doc_summary" :key="item.tpl_id">
                        <div @click="openFolder(item)"></div>
                        <p class="dir-name overhide" :title="item.tpl_name">{{ item.tpl_name }}</p>
                        <p class="dir-num">共计：{{ item.tpl_count }}</p>
                    </li>
                </ul>
                <ul class="folder" v-show="activeIndex == 1">
                    <li v-for="item in doctpl_summary" :key="item.tpl_id">
                        <div @click="openFolder(item)"></div>
                        <p class="dir-name overhide" :title="item.tpl_name">{{ item.tpl_name }}</p>
                        <p class="dir-num">共计：{{ item.tpl_doc_count }}</p>
                    </li>
                </ul>
            </z-scrollDiv>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    data() {
        return {
            tab:["任务文档","文档模板"],
            // activeIndex:0,   //tabIndex
            doc_summary:[],  //任务文件 文件夹
            doctpl_summary:[],  //文档模板  文件夹
        }
    },

    computed:{
        activeIndex(){
            return this.$route.query.tab || 0;
        }
    },

    watch:{
        activeIndex(index){
            this.getData(index);
        }
    },

    created() {
        this.getData(this.activeIndex);
    },

    methods: {
        activeTab(index){
            this.$router.push({
                name:'document-all',
                query:{
                    tab:index,
                }
            })
        },
        getData(index){
            if(index == 0){
                this.$http.get("api/clerk/task_doc/summary").then(res => {
                    if(res.status == 200){
                        this.doc_summary = res.res_data;
                    }
                });
            }else if(index == 1){
                this.$http.get("api/clerk/task_tpl/summary").then(res => {
                    if(res.status == 200){
                        this.doctpl_summary = res.res_data;
                    }
                });
            }
        },
        openFolder(item) {
            let type = this.activeIndex==0 ? "doc": "tpl";
            let id = this.$crypto.encrypt(item.tpl_id);
            let name = this.$crypto.encrypt(item.tpl_name);
            this.$router.push({
                name:"document-list",
                params:{
                    type: type,
                    id:id,
                },
                query:{
                    name:name,
                },
            })

        },

    },

}

</script>

<style scoped>
    .doc-main{
        height: calc(100% - 24px - 30px);
    }

    .btn-one,
    .btn-two {
        font-size: 12px;
        color: #4a90e2;
        letter-spacing: 0.85px;
        text-align: left;
        cursor: pointer;
        text-decoration: none;
    }

    .btn-del {
        color: #FF6B6B
    }

    .title-btn {
        margin-bottom: 15px;
        margin-top: 20px;
        height: 31px;
        font-size: 0;
    }

    .title-back {
        display: inline-block;
        font-size: 18px;
        height: 31px;
        line-height: 31px;
        color: #808080;
        letter-spacing: 1.99px;
        text-align: left;
        line-height: 31px;
        padding-left: 31px;
        margin-left: 20px;
        background: url("~src/assets/image/Stroke1.png") no-repeat left top;
        cursor: pointer;
    }

    .title-doc {
        font-size: 14px;
        color: #03b1a9;
        letter-spacing: 0.99px;
        text-align: left;
        margin-left: 10px;
        vertical-align: top;
        line-height: 31px;
    }

    .right-btn {
        float: right;
        height: 31px;
        font-size: 14px;
        line-height: 31px;
        color: #333333;
        letter-spacing: 1.55px;
        text-align: left;
    }



    /*文件上传*/

    .upload-btn {
        position: relative;
        display: inline-block;
        margin: 0 20px;
        height: 24px;
        width: 60px;
        line-height: 24px;
        background: #01b6ad;
        border-radius: 2px;
        text-align: center;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0.62px;
        cursor: pointer;
        overflow: hidden;
        transform: translateY(8px);
    }

    .upload-btn input {
        position: absolute;
        font-size: 100px;
        right: 0;
        top: 0;
        opacity: 0;
    }

    .wrap {
        height: 100%;
        box-sizing: border-box;
        /* padding: 20px; */
        overflow-y: hidden;
    }

    .wrap-docMag {
        background: #fff;
        padding: 30px;
        height: calc(100% - 60px);
        box-shadow: 0px 0px 4px 0px rgba(127, 127, 127, 0.50);
        /*box-sizing: border-box;*/
    }

    .btn-group {
        width: 160px;
        height: 24px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #4ea1d3;
    }

    button {
        width: 80px;
        font-size: 12px;
        color: #808080;
        letter-spacing: 0.99px;
        float: left;
        line-height: 24px;
        background-color: #fff;
        cursor: pointer;
    }

    button.btnSelected {
        background: #4ea1d3;
        width: 80px;
        height: 24px;
        color: #fff;
    }

    .title {
        font-size: 12px;
        color: #333333;
        letter-spacing: 0.85px;
        margin-top: 12px;
    }

    .folder {
        padding-left: 36px;
        /* height: calc(100% - 24px - 30px); */
        /* overflow: auto; */
    }

    .folder>li {
        width: 128px;
        margin: 50px;
        display: inline-block;
    }

    .folder>li>div {
        height: 101px;
        width: 100%;
        background: url("~src/assets/image/folder.png") no-repeat;
        cursor: pointer;
    }

    .folder>li>div:hover {
        background-image: url("~src/assets/image/folderHover.png");
    }

    .folder>li>p {
        font-size: 12px;
        color: #333333;
        letter-spacing: 0.85px;
        text-align: center;
        margin-top: 5px;
    }

    .folder>li>p.tpl-downloud {
        color: #4a90e2;
        cursor: pointer;
    }

    .wrap-list {
        margin: -20px -10px -10px;
        padding-bottom: 120px;
        position: relative;
        height: calc(100% - 84px);
    }

    .table-wrap {
        height: 100%;
        overflow-y: auto;
    }

    .wrap-list table {
        width: 100%;
        border-spacing: 0px 5px;
    }

    .wrap-list table tr {
        width: 100%;
        background: #ffffff;
        box-shadow: 0 0 2px 0 rgba(178, 178, 178, 0.50);
        border-radius: 4px;
    }

    .wrap-list table thead {
        border-radius: 4px;
    }

    .wrap-list table tbody tr {
        height: 50px;
    }

    .wrap-list table thead tr td {
        height: 60px;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0.99px;
    }

    .wrap-list table tr td {
        text-align: center;
        font-size: 12px;
        color: #808080;
    }

    .wrap-list table tr td:first-of-type {
        border-radius: 4px 0 0 4px;
    }

    .wrap-list table tr td:last-of-type {
        border-radius: 0 4px 4px 0;
    }

    .wrap-list table tr td:not(:nth-last-of-type(2)) {
        width: 15%;
    }

    .wrap-list table tr td:nth-last-of-type(2) {
        text-align: left;
        padding-left: 50px;
    }

    .wrap-list table tr td.wait {
        color: #ff6b6b;
    }



    /*页码*/

    /*.pagination>span {
        display: inline-block;
    }

    .pagination>span,
    .pagination>input {
        border-radius: 4px;
        height: 28px;
    }

    .pagination {
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        color: #808080;
        letter-spacing: 1.16px;
        vertical-align: top;
        margin-right: 10px;
        position: absolute;
        bottom: 20px;
        right: 20px;
    }

    .pagination-left {
        width: 28px;
        background: url(~src/assets/image/left.png) no-repeat;
        margin: 0 10px;
        cursor: pointer;
    }

    .pagination-right {
        width: 28px;
        background: url(~src/assets/image/right.png) no-repeat;
        margin: 0 10px;
        cursor: pointer;
    }

    .pagination>.pageText {
        background: #ffffff;
        border-radius: 2px;
        width: 78px;
        height: 24px;
        margin-top: 2px;
        line-height: 24px;
        text-align: center;
    }

    .pagination>span>i {
        font-style: normal;
        color: #01b6ad;
    }

    .pagination>input {
        height: 26px;
        width: 40px;
        padding-left: 10px;
        color: #808080;
        margin-left: 10px;
        box-shadow: 0px 0px 2px 0px rgba(178, 178, 178, 0.50);
    }*/
</style>




// WEBPACK FOOTER //
// page-docMange.vue?835de95a